import React, { useState } from 'react';
const PlayerCharts = () => {
  const [seasonViewMode, setSeasonViewMode] = useState('hex');
  const [lastFiveViewMode, setLastFiveViewMode] = useState('hex');
  const filters = [{
    id: 'league',
    label: 'LEAGUE',
    options: ['NBA', 'Euroleague', 'Liga ACB']
  }, {
    id: 'season',
    label: 'SEASON',
    options: ['2023-2024', '2022-2023']
  }, {
    id: 'competition',
    label: 'COMPETITION',
    options: ['Regular Season', 'Playoffs']
  }, {
    id: 'phase',
    label: 'PHASE',
    options: ['Group A', 'Group B']
  }, {
    id: 'datepicker',
    label: 'DATEPICKER',
    options: []
  }, {
    id: 'team',
    label: 'TEAM',
    options: ['New York Knicks', 'Los Angeles Lakers']
  }];
  return <div data-id="element-91">
      {/* Filters */}
      <div className="flex flex-wrap gap-2 mb-6" data-id="element-92">
        {filters.map(filter => <div key={filter.id} className="relative" data-id="element-93">
            <select className="appearance-none bg-white border rounded-md py-1 pl-3 pr-8 text-sm" data-id="element-94">
              <option value="" data-id="element-95">{filter.label}</option>
              {filter.options.map(option => <option key={option} value={option} data-id="element-96">
                  {option}
                </option>)}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" data-id="element-97">
              <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-98">
                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" data-id="element-99" />
              </svg>
            </div>
          </div>)}
      </div>
      <div className="grid grid-cols-2 gap-6" data-id="element-100">
        {/* Chart Season */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-101">
          <div className="flex justify-between items-center mb-4" data-id="element-102">
            <h3 className="font-bold" data-id="element-103">CHART SEASON</h3>
            <div className="flex bg-white border rounded-md" data-id="element-104">
              <button className={`px-3 py-1 text-xs ${seasonViewMode === 'hex' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setSeasonViewMode('hex')} data-id="element-105">
                Hex
              </button>
              <button className={`px-3 py-1 text-xs ${seasonViewMode === 'zone' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setSeasonViewMode('zone')} data-id="element-106">
                Zone
              </button>
            </div>
          </div>
          <div className="relative h-80" data-id="element-107">
            {/* Basketball half court */}
            <svg viewBox="0 0 500 400" className="w-full h-full" data-id="element-108">
              {/* Court outline */}
              <rect x="50" y="50" width="400" height="350" fill="white" stroke="black" strokeWidth="2" data-id="element-109" />
              {/* Center circle */}
              <circle cx="250" cy="50" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-110" />
              {/* Free throw line */}
              <line x1="150" y1="50" x2="350" y2="50" stroke="black" strokeWidth="2" data-id="element-111" />
              {/* Free throw circle */}
              <circle cx="250" cy="150" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-112" />
              {/* Lane */}
              <rect x="190" y="50" width="120" height="120" fill="none" stroke="black" strokeWidth="2" data-id="element-113" />
              {/* Backboard */}
              <line x1="225" y1="50" x2="275" y2="50" stroke="black" strokeWidth="4" data-id="element-114" />
              {/* Rim */}
              <circle cx="250" cy="60" r="10" fill="none" stroke="black" strokeWidth="2" data-id="element-115" />
              {/* Three point line */}
              <path d="M50,180 Q150,50 250,50 Q350,50 450,180" fill="none" stroke="black" strokeWidth="2" data-id="element-116" />
              {/* Hex zones with percentages */}
              {seasonViewMode === 'hex' && <>
                  <g transform="translate(250, 150)" data-id="element-117">
                    {/* Center hex */}
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-118" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-119">
                      42.7%
                    </text>
                  </g>
                  {/* Left corner */}
                  <g transform="translate(100, 350)" data-id="element-120">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-121" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-122">
                      29.5%
                    </text>
                  </g>
                  {/* Right corner */}
                  <g transform="translate(400, 350)" data-id="element-123">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-124" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-125">
                      26.5%
                    </text>
                  </g>
                  {/* Top left */}
                  <g transform="translate(150, 120)" data-id="element-126">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-127" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-128">
                      37.1%
                    </text>
                  </g>
                  {/* Top right */}
                  <g transform="translate(350, 120)" data-id="element-129">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-130" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-131">
                      35.8%
                    </text>
                  </g>
                  {/* Additional hexagons */}
                  <g transform="translate(200, 250)" data-id="element-132">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-133" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-134">
                      36.5%
                    </text>
                  </g>
                  <g transform="translate(300, 250)" data-id="element-135">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-136" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-137">
                      39.1%
                    </text>
                  </g>
                </>}
              {/* Shot frequency legend */}
              <g transform="translate(250, 380)" data-id="element-138">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-139">
                  SHOT FREQUENCY
                </text>
                <g transform="translate(-100, 15)" data-id="element-140">
                  <text x="-15" y="0" textAnchor="end" className="text-xs" data-id="element-141">
                    COLD
                  </text>
                  <rect x="0" y="-5" width="10" height="10" fill="#ccc" data-id="element-142" />
                  <rect x="15" y="-5" width="10" height="10" fill="#aaa" data-id="element-143" />
                  <rect x="30" y="-5" width="10" height="10" fill="#888" data-id="element-144" />
                  <rect x="45" y="-5" width="10" height="10" fill="#666" data-id="element-145" />
                  <rect x="60" y="-5" width="10" height="10" fill="#444" data-id="element-146" />
                  <text x="85" y="0" textAnchor="start" className="text-xs" data-id="element-147">
                    HOT
                  </text>
                </g>
              </g>
              {/* Stats */}
              <g transform="translate(70, 100)" data-id="element-148">
                <text x="0" y="0" className="text-xs" data-id="element-149">
                  44/103
                </text>
              </g>
              <g transform="translate(430, 100)" data-id="element-150">
                <text x="0" y="0" className="text-xs" data-id="element-151">
                  34/96
                </text>
              </g>
              <g transform="translate(70, 200)" data-id="element-152">
                <text x="0" y="0" className="text-xs" data-id="element-153">
                  26/70
                </text>
              </g>
              <g transform="translate(430, 200)" data-id="element-154">
                <text x="0" y="0" className="text-xs" data-id="element-155">
                  25/68
                </text>
              </g>
              <g transform="translate(250, 300)" data-id="element-156">
                <text x="0" y="0" textAnchor="middle" className="text-xs" data-id="element-157">
                  51/173
                </text>
              </g>
              {/* Percentages */}
              <g transform="translate(70, 115)" data-id="element-158">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-159">
                  42.7%
                </text>
              </g>
              <g transform="translate(430, 115)" data-id="element-160">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-161">
                  35.4%
                </text>
              </g>
              <g transform="translate(70, 215)" data-id="element-162">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-163">
                  37.1%
                </text>
              </g>
              <g transform="translate(430, 215)" data-id="element-164">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-165">
                  36.8%
                </text>
              </g>
              <g transform="translate(250, 315)" data-id="element-166">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-167">
                  29.5%
                </text>
              </g>
            </svg>
          </div>
        </div>
        {/* Chart Last Five */}
        <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-168">
          <div className="flex justify-between items-center mb-4" data-id="element-169">
            <h3 className="font-bold" data-id="element-170">CHART LAST FIVE</h3>
            <div className="flex bg-white border rounded-md" data-id="element-171">
              <button className={`px-3 py-1 text-xs ${lastFiveViewMode === 'hex' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setLastFiveViewMode('hex')} data-id="element-172">
                Hex
              </button>
              <button className={`px-3 py-1 text-xs ${lastFiveViewMode === 'zone' ? 'bg-black text-white' : 'text-gray-700'}`} onClick={() => setLastFiveViewMode('zone')} data-id="element-173">
                Zone
              </button>
            </div>
          </div>
          <div className="relative h-80" data-id="element-174">
            {/* Basketball half court - identical to first chart */}
            <svg viewBox="0 0 500 400" className="w-full h-full" data-id="element-175">
              {/* Court outline */}
              <rect x="50" y="50" width="400" height="350" fill="white" stroke="black" strokeWidth="2" data-id="element-176" />
              {/* Center circle */}
              <circle cx="250" cy="50" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-177" />
              {/* Free throw line */}
              <line x1="150" y1="50" x2="350" y2="50" stroke="black" strokeWidth="2" data-id="element-178" />
              {/* Free throw circle */}
              <circle cx="250" cy="150" r="60" fill="none" stroke="black" strokeWidth="2" data-id="element-179" />
              {/* Lane */}
              <rect x="190" y="50" width="120" height="120" fill="none" stroke="black" strokeWidth="2" data-id="element-180" />
              {/* Backboard */}
              <line x1="225" y1="50" x2="275" y2="50" stroke="black" strokeWidth="4" data-id="element-181" />
              {/* Rim */}
              <circle cx="250" cy="60" r="10" fill="none" stroke="black" strokeWidth="2" data-id="element-182" />
              {/* Three point line */}
              <path d="M50,180 Q150,50 250,50 Q350,50 450,180" fill="none" stroke="black" strokeWidth="2" data-id="element-183" />
              {/* Hex zones with percentages */}
              {lastFiveViewMode === 'hex' && <>
                  <g transform="translate(250, 150)" data-id="element-184">
                    {/* Center hex */}
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-185" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-186">
                      42.7%
                    </text>
                  </g>
                  {/* Left corner */}
                  <g transform="translate(100, 350)" data-id="element-187">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-188" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-189">
                      29.5%
                    </text>
                  </g>
                  {/* Right corner */}
                  <g transform="translate(400, 350)" data-id="element-190">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-191" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-192">
                      26.5%
                    </text>
                  </g>
                  {/* Top left */}
                  <g transform="translate(150, 120)" data-id="element-193">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-194" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-195">
                      37.1%
                    </text>
                  </g>
                  {/* Top right */}
                  <g transform="translate(350, 120)" data-id="element-196">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-197" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-198">
                      35.8%
                    </text>
                  </g>
                  {/* Additional hexagons */}
                  <g transform="translate(200, 250)" data-id="element-199">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-200" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-201">
                      36.5%
                    </text>
                  </g>
                  <g transform="translate(300, 250)" data-id="element-202">
                    <polygon points="0,-30 26,-15 26,15 0,30 -26,15 -26,-15" fill="#ccc" fillOpacity="0.5" stroke="#666" data-id="element-203" />
                    <text x="0" y="0" textAnchor="middle" dominantBaseline="middle" className="text-xs font-bold" data-id="element-204">
                      39.1%
                    </text>
                  </g>
                </>}
              {/* Shot frequency legend */}
              <g transform="translate(250, 380)" data-id="element-205">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-206">
                  SHOT FREQUENCY
                </text>
                <g transform="translate(-100, 15)" data-id="element-207">
                  <text x="-15" y="0" textAnchor="end" className="text-xs" data-id="element-208">
                    COLD
                  </text>
                  <rect x="0" y="-5" width="10" height="10" fill="#ccc" data-id="element-209" />
                  <rect x="15" y="-5" width="10" height="10" fill="#aaa" data-id="element-210" />
                  <rect x="30" y="-5" width="10" height="10" fill="#888" data-id="element-211" />
                  <rect x="45" y="-5" width="10" height="10" fill="#666" data-id="element-212" />
                  <rect x="60" y="-5" width="10" height="10" fill="#444" data-id="element-213" />
                  <text x="85" y="0" textAnchor="start" className="text-xs" data-id="element-214">
                    HOT
                  </text>
                </g>
              </g>
              {/* Stats */}
              <g transform="translate(70, 100)" data-id="element-215">
                <text x="0" y="0" className="text-xs" data-id="element-216">
                  44/103
                </text>
              </g>
              <g transform="translate(430, 100)" data-id="element-217">
                <text x="0" y="0" className="text-xs" data-id="element-218">
                  34/96
                </text>
              </g>
              <g transform="translate(70, 200)" data-id="element-219">
                <text x="0" y="0" className="text-xs" data-id="element-220">
                  26/70
                </text>
              </g>
              <g transform="translate(430, 200)" data-id="element-221">
                <text x="0" y="0" className="text-xs" data-id="element-222">
                  25/68
                </text>
              </g>
              <g transform="translate(250, 300)" data-id="element-223">
                <text x="0" y="0" textAnchor="middle" className="text-xs" data-id="element-224">
                  51/173
                </text>
              </g>
              {/* Percentages */}
              <g transform="translate(70, 115)" data-id="element-225">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-226">
                  42.7%
                </text>
              </g>
              <g transform="translate(430, 115)" data-id="element-227">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-228">
                  35.4%
                </text>
              </g>
              <g transform="translate(70, 215)" data-id="element-229">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-230">
                  37.1%
                </text>
              </g>
              <g transform="translate(430, 215)" data-id="element-231">
                <text x="0" y="0" className="text-xs font-bold" data-id="element-232">
                  36.8%
                </text>
              </g>
              <g transform="translate(250, 315)" data-id="element-233">
                <text x="0" y="0" textAnchor="middle" className="text-xs font-bold" data-id="element-234">
                  29.5%
                </text>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>;
};
export default PlayerCharts;